import { DataSTag, Sel } from '#~/stag/index.js';
import { Button } from '@studio/design-system/button';
import { dayjs } from '@studio/js-utils/time';
import { useMemo } from 'react';
import { twMerge } from 'cn';
// import { Error } from './components/index.js';
import type { BillingInfo } from './types.js';
import { Spinner } from '@studio/design-system/spinner';

interface Props {
  billing: BillingInfo;
  className?: string;
  onCtaClick?: () => void;
  loading: boolean;
  changeDisabled?: boolean;
  showChange?: boolean;
}

/** Upcoming Invoice component. */
export const UpcomingInvoiceCard = ({
  loading,
  billing,
  className,
  onCtaClick,
  changeDisabled = false,
  showChange = true
}: Props) => {
  const planDetails = billing.upcomingBilling;

  const billingPrice = useMemo(() => {
    return (
      <span>
        {planDetails.currencyPrefix}
        {planDetails.amount.toFixed(2)}
        {planDetails.currencySuffix}
      </span>
    );
  }, [billing, planDetails]);

  const ctaText = billing.activePlan.planSystem === 'free' ? 'Upgrade Plan' : 'Change Plan';

  if (loading) {
    return (
      <div className={twMerge('flex flex-col rounded-8 bg-dark', className)}>
        <div className='flex items-center justify-between border-b-1 border-b-base-100 p-20'>
          <div className='mb-0 text-lg font-demibold leading-100'>Upcoming Invoice</div>
        </div>

        <div className='flex grow flex-col p-20'>
          <div className='flex grow items-center gap-6 text-center'>
            <Spinner className='mx-auto' />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={twMerge('rounded-8 bg-dark', className)}>
      <div className='border-b-1 border-b-base-100 p-20'>
        <div className='flex items-end gap-8'>
          <div className='mb-0 text-lg font-demibold leading-100'>Upcoming Invoice</div>
          <span className='text-sm text-primary'>{billing.activePlan.planHuman}</span>
        </div>
        <div />
      </div>
      <div className='p-20'>
        <div className='flex items-center gap-20'>
          <h1 className='my-0 text-2xl'>{billingPrice}</h1>
          <div className='flex flex-col gap-6'>
            <div className='font-demibold'>Billing Date</div>
            <div className='text-sm font-regular text-muted'>
              {dayjs(billing.upcomingBilling.to).format('M/D/YYYY')}
            </div>
          </div>
        </div>
        <div className='flex items-end justify-between gap-x-12'>
          {showChange && (
            <Button
              {...DataSTag(Sel.AccountSettings, 'change-plan')}
              className='mt-24'
              onClick={onCtaClick}
              disabled={changeDisabled}
            >
              {ctaText}
            </Button>
          )}
          {/* {!!error && <Error>{error}</Error>} */}
        </div>
      </div>
    </div>
  );
};
